import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Magnifier"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("rect", {
  width: "0.96",
  height: "1.3071",
  transform: "matrix(0.707121 -0.707092 0.707121 0.707092 10.4668 10.9061)",
  fill: "#737E99"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("rect", {
  width: "1.92",
  height: "5.35493",
  rx: "0.72",
  transform: "matrix(0.707121 -0.707092 0.707121 0.707092 10.8535 11.9705)",
  fill: "#737E99"
}, null, -1);
const _hoisted_4 = /* @__PURE__ */ createElementVNode("circle", {
  cx: "6.96109",
  cy: "6.72",
  r: "5.12",
  stroke: "#737E99",
  "stroke-width": "1.44"
}, null, -1);
const _hoisted_5 = /* @__PURE__ */ createElementVNode("path", {
  d: "M9.65299 6.44762C9.85601 6.48568 10.0372 6.32266 10.0107 6.11781C9.99545 5.99978 9.97275 5.88139 9.94228 5.76318C9.57741 4.3476 8.22492 3.44831 6.81247 3.61272C6.60777 3.63655 6.49333 3.852 6.57841 4.0397C6.64274 4.18163 6.79826 4.24951 6.95352 4.23623C8.03088 4.14408 9.04896 4.8396 9.32784 5.92155C9.34581 5.99127 9.36031 6.06106 9.37147 6.13076C9.39605 6.2844 9.50005 6.41895 9.65299 6.44762Z",
  fill: "#737E99"
}, null, -1);
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_6);
}
var magnifier = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { magnifier as default };
